import { useParams } from "react-router-dom";
import useOrderStore from "../../../stores/useOrderStore";
import { useEffect } from "react";
import show from "../../../api/auth/orders/show";
import { Stack, Typography } from "@mui/material";
import WushCard from "../../../components/layout/WushCard";

export default function Checkout() {
  const { updateOrder, orderById } = useOrderStore();

  const { id } = useParams();

  const order = orderById(id);

  useEffect(() => {
    show(id, (response) => {
      updateOrder(response);
    });
  }, []);

  return (
    <Stack px={{ sm: "10%" }}>
      <WushCard>
        <Stack p={2}>
          <Stack>
            <Typography variant="h4">Order #{order.id}</Typography>
          </Stack>
        </Stack>
      </WushCard>
    </Stack>
  );
}